<template>
    <div
        class="md product-list"
        :class="['is-'+ showType]"
    >
        <ul>
            <li
                v-for="item in list"
                :key="item.sn"
                @click="viewItem(item)"
            >
                <router-link
                    class="div"
                    :to="'/system/productList?class='+ (productClassSN || item.class[0] || 'all'|| 'offGrade') +'&product='+ (productM || 'all'|| 'offGrade' ) +'&item='+ item.sn"
                >
                    <div
                        class="image"
                    >
                        <div v-if="item.label" class="label">{{ productM === 'offGrade'? $siteTool.getLabelClassName('副牌料') :$siteTool.getLabelClassName(item.label) }}</div>
                        <div
                            class="mask"
                            :style="{
                                'background-image': 'url('+ item.image +')',
                                'background-size': $siteConfig.emptyProductPhoto === item.image? 'contain': 'cover',
                            }"
                        ></div>
                        <img :src="item.image">
                    </div>
                    <div class="essay">
                        <div class="func">
                            <ul>
                                <li
                                    class="is-favorite"
                                    :class="[item.favorite? 'is-active': '']"
                                >
                                    <div  class="a" :title="item.favorite ? $t('site.func.removefavorite') : $t('site.func.addfavorites')" @click.prevent.stop="favorite(item)">
                                        <span>{{ $t('site.func.addfavorites') }}</span>
                                    </div>
                                </li>
                                <li class="is-contact">
                                    <div class="a" :title="$t('site.func.contactsales')" @click.prevent.stop="contact(item)">
                                        <span>{{ $t('site.func.contactsales') }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="caption">{{ item.alias || item.caption }}</div>
                        <div class="p">{{ item.essay }}</div>
                        <div
                            v-if="typeof $siteTool.getPrice(item.node) === 'number'"
                            class="label"
                        >{{ 'NT$ '+ $okaTool.numberToStringFormat($siteTool.getPrice(item.node)) }}</div>
                        <div
                            v-else
                            class="label is-alert"
                        >{{ $siteTool.getPrice(item.node) }}</div>
                    
                    </div>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        props: {
            showType: {
                type: String,
                require: false,
                default: 'table'
            },
            list:{
                type: Array,
                require: false,
                default: function() {
                    return []
                }
            }
        },
        computed: {
            ...mapState([
                'productListInit',
            ]),
            query: function(){
                return this.$route.query || {}
            },
            productClassSN: function(){
                return this.query.class;
            },
            productM: function(){
                return this.query.product;
            },
        },
        methods: {
            ...mapMutations([
                'initProductData',
            ]),
            favorite: function(item){
                this.$emit('sendEvent', 'favorite', item);
            },
            contact: function(item){
                this.$emit('sendEvent', 'contact', item.sn);
            },
            viewItem: function(item){
                let $data = item.node;

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: "view_item",
                    ecommerce: {
                        currency: "TWD",
                        value: $data.price,
                        items: [
                            {
                                item_id: $data.product_sn,
                                item_name: $data.product_s,
                                item_brand: "Formosa Plastic Corporation",
                                item_category: $data.product_b,
                                item_category2: $data.product_m,
                                item_category3: $data.product_s,
                            }
                        ]
                    }
                });
            }
        },
        created: function(){
            let _date = new Date().toLocaleDateString();

            if( _date !== this.productListInit ) {
                this.initProductData();
            }
        }
    }
</script>

<style scoped lang="scss">
    
    .md.product-list {

        &.is-table {
            
            > ul {

                > li {
                    display: inline-block;
                    width: 20%;

                    @include media('center') {
                        width: 25%;
                    }

                    @include media('pad') {
                        width: 33.3%;
                    }

                    @include media('phone') {
                        width: 50%;
                    }
                }
            }
            
            .div {

            }

            .image {

                .label {
                    top: $interval-s;
                    left: $interval-s;
                    // width: 75px;
                    // padding-bottom: 18%;
                }
                
                .mask {
                    padding-bottom: 100%;
                    border-radius: $border-radius;
                }

                img {
                    
                }
            }

            .essay {

                .func {
                    bottom: 100%;
                    right: 0;
                }
            }
        }

        &.is-list {
            
            .div {
                display: flex;
            }

            .image {
                width: 120px;
                z-index: 1;

                .label {
                    top: $interval-m;
                    left: 100%;
                    margin-left: $interval-s;
                    font-size: $font-size-s;
                    // width: 50px;
                    // padding-bottom: 22%;
                }
                
                .mask {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    border-radius: $border-radius 0 0 $border-radius;
                }
            }

            .essay {
                flex: 1;
                background-color: #ECECEC;
                padding-top: 42px;
                padding-left: $interval-m;
                border-radius: 0 $border-radius $border-radius 0;

                .func {
                    bottom: 0;
                    right: 0;

                    li {
                        
                    }

                    .a {
                        padding: $interval-s $interval-m;

                        @include media('phone') {
                            padding: $interval-s;
                        }

                        &:before {
                            display: inline-block;
                            margin-right: $interval-s;
                        }

                        span {
                            display: inline;

                            @include media('phone') {
                                display: none;
                            }
                        }
                    }
                }
            }
        }

        > ul {

            > li {

            }
        }

        ul {
            @extend %reset;
        }

        li {

        }
        
        .div {
            display: block;
            padding: $interval-s;
            cursor: pointer;
            color: inherit;
        }

        .image {
            position: relative;

            .label {
                position: absolute;
                padding: $interval-xs $interval-s;
                // border-radius: $border-radius;
                white-space: nowrap;
                color: $white;
                background-color: $tag-color;
                text-shadow: 1px 1px 2px $gray;
                font-weight: 900;
                border-radius: $border-radius;
                
                // border: $border;
                // border-color: $minor-color;
                // background-size: contain;
                // background-position: center;
                // background-repeat: no-repeat;

                // &.spec {
                //     // background-image: image-url('spec.png');
                // }

                // &.hot {
                //     background-image: image-url('hot.png');
                // }

                // &.new {
                //     background-image: image-url('new.png');
                // }

                // &.sale {
                //     background-image: image-url('sale.png');
                // }

            }
            
            .mask {
                display: block;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                background-color: $minor-color;
            }

            img {
                display: none;
            }
        }

        .essay {
            position: relative;
            padding: $interval-s;
            transition: $transition;

            .func {
                position: absolute;

                ul {
                    position: absolute;
                    right: $interval-s;
                    bottom: $interval-s;
                    white-space: nowrap;
                }

                li {
                    display: inline-block;

                    + li {
                        margin-left: $interval-s;
                    }

                    &.is-favorite {

                        &.is-active {
                            $type: map-get($colors, 'danger');
                            $text: map-get($type, 'text');

                            .a {

                                &:before {
                                    content: '\e87d';
                                    color: $text;
                                }
                            }
                        }

                        .a {

                            &:before {
                                content: '\e87e';
                            }
                        }
                    }

                    &.is-contact {

                        .a {

                            &:before {
                                content: '\e0cb';
                            }
                        }
                    }
                }

                .a {
                    $size: 18px;

                    display: block;
                    line-height: $size;
                    text-align: center;
                    cursor: pointer;
                    transition: $transition;
                    border-radius: $border-radius;
                    white-space: nowrap;
                    padding: $interval-s;
                    transition: $transition;
                    background-color: rgba-set($white, $opacity-m);
                    // color: $forth-color;
                    // border: $border;
                    // border-color: $major-color;

                    &:hover {
                        background-color: $major-color;
                        color: $white;
                    }

                    &:before {
                        @extend %font-pseudo;
                        font-size: $font-size-xl;
                        display: block;
                        width: $size;
                        height: $size;
                        line-height: $size;
                        text-align: center;
                        cursor: pointer;
                    }

                    span {
                        display: none;
                    }
                }
            }

            .caption {
                font-weight: bold;
            }

            .p {
                // color: $major-color;
                @extend %ellipsis;
            }

            .label {
                margin-top: $interval-s;
                font-weight: bold;
                color: #ee4d2d;

                &.is-alert {

                    &::before {
                        $type: map-get($colors, 'danger');
                        $text: map-get($type, 'text');

                        @extend %font-pseudo;
                        position: relative;
                        content: '\e001';
                        margin-right: $interval-xs;
                        color: $text;
                        vertical-align: bottom;
                    }
                }
            }
        }
    }
</style>
